import { RHFTextField } from './rhf-text-field';

// Namespace export so call sites read as <Field.Text name="email" /> (mirrors v1).
// Add Field.Switch, Field.Select, etc. here as new field types are introduced.
export const Field = {
  Text: RHFTextField,
};
